/**
 * @author        luis.orihuela@zumper.com ()
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Message Sent Component
 */
import { Flex, Heading, Link, Text } from '@chakra-ui/react'
import { GreenCheckMark, PhoneCall } from '@zcode-ui/icons'
import { checkLoggedIn } from '@zcode-ui/web-zumper-global-state'
import type { Property } from '@zcode/state-type'
import { format } from 'date-fns'
import React from 'react'
import { useSelector } from 'react-redux'

interface MessageSentProps {
  heading?: string
  messageSentTime: number | null
  paidPhone?: Property['paidPhone']
  paidPhoneHref?: Property['paidPhoneHref'] | null
}

const DATE_FORMAT = "M/dd/yyyy 'at' h:mm aa"
export const MessageSent = ({
  heading,
  messageSentTime,
  paidPhone,
  paidPhoneHref,
}: MessageSentProps) => {
  const date = messageSentTime && new Date(messageSentTime * 1000)
  const isLoggedIn = useSelector(checkLoggedIn)
  const formattedDate = date && format(date, DATE_FORMAT).toLowerCase()
  const showPaidPhoneContact = !!paidPhone && !!paidPhoneHref
  const notLoggedInDefaultMessage =
    !isLoggedIn && !showPaidPhoneContact ? 'One step closer to finding your home.' : ''
  return (
    <Flex direction="column" alignItems="center" py={2}>
      <Heading display="flex" alignItems="center" fontSize="lg" gap={2}>
        <GreenCheckMark />
        {heading ? heading : 'Message sent'}
      </Heading>
      <Text marginTop={2} variant="body16Md" color="gray.600">
        {isLoggedIn && formattedDate ? formattedDate : notLoggedInDefaultMessage}
      </Text>
      {showPaidPhoneContact ? (
        <Flex mt={6} direction="column" alignItems="center" gap={2}>
          <Text variant="body16Md" color="gray.950" textAlign="center">
            Eager to get this apartment? You can follow up with a phone call:
          </Text>
          <Flex alignItems="center" justifyContent="center" gap={2}>
            <PhoneCall size={20} stroke="var(--chakra-colors-gray-950)" />
            <Link
              fontWeight="medium"
              _hover={{ color: 'gray.950', textDecoration: 'underline' }}
              href={paidPhoneHref}
              textDecoration="none"
            >
              {paidPhone}
            </Link>
          </Flex>
        </Flex>
      ) : null}
    </Flex>
  )
}
